// extracted by mini-css-extract-plugin
export var activeTab = "feature-tabs-module--activeTab--ccd80";
export var content = "feature-tabs-module--content--12384";
export var feature = "feature-tabs-module--feature--cb48d";
export var featureSingle = "feature-tabs-module--featureSingle--ee406";
export var features = "feature-tabs-module--features--99bd6";
export var featuresSingle = "feature-tabs-module--featuresSingle--bff88";
export var mainImage = "feature-tabs-module--mainImage--143d5";
export var root = "feature-tabs-module--root--c32b7";
export var tab = "feature-tabs-module--tab--c3ed9";
export var tabs = "feature-tabs-module--tabs--f0b22";
export var titleContainer = "feature-tabs-module--titleContainer--c1645";